const splitHtmlLines = value =>
  typeof value === 'string'
    ? ['&#013;', '&#010;', '&#13;', '&#10;', '\\r\\n', '\\n', '\\A']
      .reduce((acc, pattern) => acc.replaceAll(pattern, '\n'), value)
    : value;

export default splitHtmlLines;